import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import toast from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { getRedirectUrl } from '../../lib/deepLinks';

const { FiMail } = FiIcons;

const ForgotPasswordForm = () => {
    const { supabase } = useAuth();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const { error } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: getRedirectUrl('/reset-password'),
            });

            if (error) throw error;

            setMessage('Password reset link sent! Please check your email.');
            toast.success(`Password reset link sent for domain: app.lifecoachassist.ai!`);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 mt-4 pt-safe">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-md mx-auto"
            >
                <div className="bg-white rounded-2xl shadow-xl p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Forgot Password?</h2>
                    <p className="text-gray-600">Enter your email to reset your password</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Email Address
                        </label>
                        <div className="relative">
                            <SafeIcon
                                icon={FiMail}
                                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                            />
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Enter your email"
                            />
                        </div>
                    </div>

                    <motion.button
                        type="submit"
                        disabled={loading}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </motion.button>
                </form>

                {message && (
                    <div className="mt-4 text-center text-green-600">
                        {message}
                    </div>
                )}

                <div className="mt-6 text-center">
                    <Link
                        to="/auth"
                        className="text-sm text-blue-600 hover:text-blue-800 hover:underline transition-colors"
                    >
                        Remember your password? Log in here
                    </Link>
                </div>

            </div>
        </motion.div>
        </div>
    );
};

export default ForgotPasswordForm;